import { render, staticRenderFns } from "./wxMemoryBaseAddress.vue?vue&type=template&id=492adcc9"
import script from "./wxMemoryBaseAddress.vue?vue&type=script&lang=js"
export * from "./wxMemoryBaseAddress.vue?vue&type=script&lang=js"
import style0 from "./wxMemoryBaseAddress.vue?vue&type=style&index=0&id=492adcc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports